import React, { useState } from "react";
import FontForm from "./FontForm";
import { addFont } from "../../../api/fontService";

export default function AddFont() {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (formData) => {
    setLoading(true);

    try {
      const res = await addFont(formData);
      return res;
    } catch (err) {
      return err?.response?.data;
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container p-4">
      <div className="card p-4">
        

        <FontForm
          onSubmit={handleSubmit}
          loading={loading}
          buttonText="Add Font"
        />
      </div>
    </div>
  );
}
